module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_14.png?1167c4919e67a9d23ba6db0ba911eaf8";